<template>
  <div class="order-details">
    <!-- 给header上与data上加on为退款订单-->
    <div class="header bg-color-red acea-row row-middle">
      <div class="pictrue">
        <img src="@assets/images/orderTime.png" />
      </div>
      <div class="data">
        <div class="state">{{ offDetail.c_flowname }}</div>
      </div>
    </div>
    <template>
      <div class="address">
        <div class="name">
          {{ offDetail.c_clientname }}
          <span class="phone">{{ userInfo.phone }}</span>
        </div>
        <!-- <div>地址</div> -->
      </div>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </template>
    <OrderUpGoods :cartInfo="offDetail"></OrderUpGoods>
    <div class="wrapper">
      <div class="item acea-row row-between" v-if="offDetail.className != ''">
        <div>商品类别:</div>
        <div class="conter">{{ offDetail.className }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_left_right != ''"
      >
        <div>左镜片/右镜片:</div>
        <div class="conter">{{ offDetail.c_left_right }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_ball != ''"
      >
        <div>球镜:</div>
        <div class="conter">{{ offDetail.c_ball }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_pole != ''"
      >
        <div>柱镜:</div>
        <div class="conter">{{ offDetail.c_pole }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_axes != ''"
      >
        <div>轴向:</div>
        <div class="conter">{{ offDetail.c_axes }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_add != ''"
      >
        <div>下加度:</div>
        <div class="conter">{{ offDetail.c_add }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_space != ''"
      >
        <div>远瞳距:</div>
        <div class="conter">{{ offDetail.c_space }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_space2 != ''"
      >
        <div>近瞳距:</div>
        <div class="conter">{{ offDetail.c_space2 }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_ph != ''"
      >
        <div>右瞳高:</div>
        <div class="conter">{{ offDetail.c_ph }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_ph1 != ''"
      >
        <div>左瞳高:</div>
        <div class="conter">{{ offDetail.c_ph1 }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_prism != ''"
      >
        <div>棱镜:</div>
        <div class="conter">{{ offDetail.c_prism }}</div>
      </div>
      <div
        class="item acea-row row-between"
        v-if="offDetail.className == '镜片' && offDetail.c_floor != ''"
      >
        <div>基底:</div>
        <div class="conter">{{ offDetail.c_floor }}</div>
      </div>
    </div>

    <div class="wrapper">
      <div class="item acea-row row-between">
        <div>订单编号：</div>
        <div class="conter acea-row row-middle row-right">
          {{ offDetail.c_retailcode }}
          <span
            class="copy copy-data"
            :data-clipboard-text="offDetail.c_retailcode"
            >复制</span
          >
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>收银时间：</div>
        <div class="conter">{{ offDetail.c_shou_date }}</div>
      </div>
      <div class="item acea-row row-between" v-if="offDetail.c_realtake != ''">
        <div>取镜时间：</div>
        <div class="conter">{{ offDetail.c_realtake }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>定做备注：</div>
        <div class="conter">{{ offDetail.order_memo }}</div>
      </div>
      <div class="actualPay acea-row row-right">
        总金额：
        <span class="money font-color-red"
          >￥{{ offDetail.c_price_amount }}</span
        >
      </div>
    </div>
    <div class="geoPage" v-if="mapShow">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
            system_store.latitude +
            ',' +
            system_store.longitude +
            '&referer=' +
            mapKey
        "
      ></iframe>
    </div>
  </div>
</template>
<style scoped>
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.order-details .writeOff {
  background-color: #fff;
  margin-top: 0.13rem;
  padding-bottom: 0.3rem;
}
.order-details .writeOff .title {
  font-size: 0.3rem;
  color: #282828;
  height: 0.87rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0.3rem;
  line-height: 0.87rem;
}
.order-details .writeOff .grayBg {
  background-color: #f2f5f7;
  width: 5.9rem;
  height: 3.84rem;
  border-radius: 0.2rem 0.2rem 0 0;
  margin: 0.5rem auto 0 auto;
  padding-top: 0.55rem;
}
.order-details .writeOff .grayBg .pictrue {
  width: 2.9rem;
  height: 2.9rem;
  margin: 0 auto;
}
.order-details .writeOff .grayBg .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .gear {
  width: 5.9rem;
  height: 0.3rem;
  margin: 0 auto;
}
.order-details .writeOff .gear img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .num {
  background-color: #f0c34c;
  width: 5.9rem;
  height: 0.84rem;
  color: #282828;
  font-size: 0.48rem;
  margin: 0 auto;
  border-radius: 0 0 0.2rem 0.2rem;
  text-align: center;
  padding-top: 0.04rem;
}
.order-details .writeOff .rules {
  margin: 0.46rem 0.3rem 0 0.3rem;
  border-top: 0.01rem solid #f0f0f0;
  padding-top: 0.1rem;
}
.order-details .writeOff .rules .item {
  margin-top: 0.15rem;
}
.order-details .writeOff .rules .item .rulesTitle {
  font-size: 0.28rem;
  color: #282828;
}
.order-details .writeOff .rules .item .rulesTitle .iconfont {
  font-size: 0.3rem;
  color: #333;
  margin-right: 0.08rem;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info {
  font-size: 0.28rem;
  color: #999;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info .time {
  margin-left: 0.2rem;
}
.order-details .map {
  height: 0.86rem;
  font-size: 0.3rem;
  color: #282828;
  line-height: 0.86rem;
  border-bottom: 0.01rem solid #f0f0f0;
  margin-top: 0.13rem;
  background-color: #fff;
  padding: 0 0.3rem;
}
.order-details .map .place {
  font-size: 0.26rem;
  width: 1.76rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
}
.order-details .map .place .iconfont {
  font-size: 0.27rem;
  height: 0.27rem;
  line-height: 0.27rem;
  margin: 0.02rem 0.03rem 0 0;
}
.order-details .address .name .iconfont {
  font-size: 0.34rem;
  margin-left: 0.1rem;
}
</style>
<script>
import OrderUpGoods from "@components/OrderUpGoods";
import ClipboardJS from "clipboard";
import { mapGetters } from "vuex";

const NAME = "OrderDetails";

export default {
  name: NAME,
  components: {
    OrderUpGoods
  },
  props: {},
  data: function() {
    return {
      offlinePayStatus: 2,
      orderTypeName: "普通订单",
      orderTypeNameStatus: true,
      offlineStatus: true,
      id: this.$route.params.id,
      offlineDetail: [],
      offDetail: {},
      orderInfo: {
        _status: {}
      },
      status: {},
      pay: false,
      system_store: {},
      mapKay: "",
      mapShow: false
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.getUpDetail();
      }
    }
  },
  inject: ["app"],
  mounted: function() {
    this.getUpDetail();
    this.$nextTick(function() {
      let copybtn = document.getElementsByClassName("copy-data");
      const clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", () => {
        this.$dialog.success("复制成功");
      });
    });
  },
  methods: {
    getUpDetail() {
      const id = this.id;
      if (id == "") return this.$dialog.error("订单不存在");
      this.offlineDetail = sessionStorage.getItem("offLineData");
      for (var i in eval(this.offlineDetail)) {
        if (i == id) {
          this.offDetail = eval(this.offlineDetail)[id];
        }
      }
    }
  }
};
</script>
